import { render, staticRenderFns } from "./complianceAction.vue?vue&type=template&id=5d13564c"
import script from "./complianceAction.vue?vue&type=script&lang=js"
export * from "./complianceAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d13564c')) {
      api.createRecord('5d13564c', component.options)
    } else {
      api.reload('5d13564c', component.options)
    }
    module.hot.accept("./complianceAction.vue?vue&type=template&id=5d13564c", function () {
      api.rerender('5d13564c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/pca/action/complianceAction.vue"
export default component.exports